import { InjectionToken } from '@angular/core';

import { DiskPreloadUrlPatternEntry } from './disk-preload-url-pattern-entry.model';

export const DISK_PRELOAD_URL_PATTERNS = new InjectionToken<ReadonlyArray<DiskPreloadUrlPatternEntry>>('DISK_PRELOAD_URL_PATTERNS');
